<template>
    <div class="flex" style="padding-left: 2rem;">
        <div class="code-output-formats flex">
            <label class="code-output-format" :class="{selected: current === formats.hex}">
                <span>HEX</span>
                <input type="radio" v-model="current" name="format" :value="formats.hex" @change="input">
            </label>
            <label class="code-output-format" :class="{selected: current === formats.rgb}" style="margin: 0 4px">
                <span>RGB</span>
                <input type="radio" v-model="current" name="format" :value="formats.rgb" @change="input">
            </label>
            <label class="code-output-format" :class="{selected: current === formats.hsl}">
                <span>HSL</span>
                <input type="radio" v-model="current" name="format" :value="formats.hsl" @change="input">
            </label>
        </div>
    </div>
</template>

<script>
    import Hex from '../../Outputs/Formats/Hex'
    import Rgb from '../../Outputs/Formats/Rgb';
    import Hsl from '../../Outputs/Formats/Hsl';

    export default {
        name: 'ColorFormatPicker',
        props: {
            value: {},
        },

        data() {
            return {
                current: null,
                formats: {
                    hex: Hex,
                    rgb: Rgb,
                    hsl: Hsl,
                },
            }
        },

        methods: {
            input() {
                this.$emit('input', this.current);
            },
        },

        mounted() {
            this.current = this.value;
        },

    }
</script>

<style scoped lang="scss">

    @import '../../../../../sass/variables';

    .code-output-formats {
        background-color: $body-accent;
        border-radius: $round;
    }

    .code-output-format {
        display: flex;
        padding: 3px 8px;
        border-radius: $round;

        &.selected {
            background-color: $body-bg;
        }

        input {
            display: none;
        }
    }

</style>